<template>
	<div class="paymentOrder">
		<div id="big">
			<div id="header">
				<img id="imgFanhui" @click="fanhui" src="../../../../assets/fanhui.png" />
				支付订单
			</div>
			<div id="main">
				<div id="money">
					<p>
						<a>购买项目</a>
						<span id="yuanjia">{{ form3.payName }} </span>
					</p>
					<p>
						<a>有效期至</a>
						<span id="youhui">{{ form3.endTime }}</span>
					</p>
					<p style="border: none;">
						<a>支付金额</a>
						<span id="xuyao">{{ form3.amount }}</span>
					</p>
				</div>
				<div class="table-main">
					<p style="border: none;">
						<a>开具发票</a>
						<span v-if="type != '1'" style="cursor: pointer;" class="fp fps" @click="fp(2)">不要发票</span>
						<span v-else style="cursor: pointer;" class="fp" @click="fp(2)">不要发票</span>
						<span v-if="type == '1'" style="cursor: pointer;" class="fp fps" @click="fp(1)">开发票</span>
						<span v-else style="cursor: pointer;" class="fp" @click="fp(1)">开发票</span>
					</p>
				</div>
				<div v-if="type == '1'" style="background: #fff;">
					<van-collapse v-model="activeNames">
						<div v-if="invoiceId != '' || invoiceId != null">
							<div id="gs" v-if="form1.invoiceHead == '2'">公司（普通电子发票)</div>
							<div id="gs" v-if="form1.invoiceHead == '1'">个人（普通电子发票)</div>
						</div>
						<van-collapse-item title="发票信息" name="1">
							<!-- <div class="table-main"><p><a>发票信息</a><span style="cursor: pointer;">点击填写发票信息</span></p></div> -->
							<!-- <div class="table-kfp"><p>发票信息</p></div> -->
							<!-- <div class="table-main1">
								<p>
									<a>发票类型</a>
									<span v-text="form1.invoiceType"></span>
								</p>
							</div> -->
							<div class="table-main1">
								<p>
									<a>发票明细</a>
									<input class="inputs" type="text" v-model.trim="mx" disabled placeholder="输入个人或企业名称" />
								</p>
							</div>

							<div class="table-main1">
								<p>
									<a>抬头类型</a>
									<span>
										<input type="radio" :disabled="disableds" name="love" v-model="form1.invoiceHead" value="2" />
										公司
										<input style="margin-left: 0.5rem;" type="radio" :disabled="disableds" name="love" v-model="form1.invoiceHead"
										 value="1" />
										个人
									</span>
								</p>
							</div>



							<div class="table-main1">
								<p>
									<a>发票抬头</a>
									<input class="inputs" type="text" v-model.trim="form1.invoiceCompe" :disabled="disableds" placeholder="输入个人或企业名称" />
								</p>
							</div>
							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>税号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业纳税人识别码" v-model.trim="form1.socialCreditCode" />
								</p>
							</div>

							<div class="table-main1" v-if="form1.invoiceHead == 1">
								<p style="border: none;">
									<a>身份证号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入身份证号" v-model.trim="form1.socialCreditCode" />
								</p>
							</div>

							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>开户银行</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入开户银行" v-model="form1.bankName" />
								</p>
							</div>

							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>银行账号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入银行账号" v-model="form1.bankNumber" />
								</p>
							</div>

							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>企业地址</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业地址" v-model="form1.address" />
								</p>
							</div>

							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>企业电话</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业电话" v-model="form1.phone" />
								</p>
							</div>


							<div class="table-kfp">
								<p>接收方式</p>
							</div>
							<div class="table-main1">
								<p>
									<a>邮箱</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="用于向您发送电子发票" v-model="form1.invoiceEmail" />
								</p>
							</div>
							<div class="table-main1">
								<p style="border: none;">
									<a>手机号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入手机号" v-model="form1.invoicePhone" />
								</p>
							</div>


							<div class="table-kfp">
								<p>发票总额</p>
							</div>
							<div class="table-main1">
								<p style="border: none;">
									<a>总金额</a>
									<span style="margin-left: 0.2rem;">元</span>
									<input class="inputs" type="text" placeholder="输入金额" v-model="form3.amount" disabled style="width: 30%;" />
								</p>
							</div>
							<div class="table-mainss" v-if="this.invoiceId == ''">
								<span style="cursor: pointer;float: left;" class="fpss" :disabled="disableds" @click="qx">取消填写</span>
								<span style="cursor: pointer;float: right;" class="fpss1" @click="qd" :disabled="disableds">确定发票信息</span>
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>
				<div v-if="repeatBtn == 1">
					<div v-if="form.isToll == '2'" id="btn" @click="zf1">支付订单</div>
					<div v-else id="btn" @click="zf">支付订单</div>
				</div>
				<div v-if="repeatBtn == 2">
					<div id="btn">支付订单</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Toast,
		Sidebar,
		List,
		SidebarItem,
		PullRefresh,
		Overlay,
		Tab,
		Tabs,
		Cell,
		Loading,
		Collapse,
		CollapseItem,
		Button,
		RadioGroup,
		Radio,
		Notify,
		Dialog
	} from 'vant';
	import request from '@/utils/request';
	export default {
		components: {
			[Toast.name]: Toast,
			[Sidebar.name]: Sidebar,
			[List.name]: List,
			[SidebarItem.name]: SidebarItem,
			[PullRefresh.name]: PullRefresh,
			[Overlay.name]: Overlay,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Cell.name]: Cell,
			[Loading.name]: Loading,
			[Collapse.name]: Collapse,
			[CollapseItem.name]: CollapseItem,
			[Button.name]: Button,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[Notify.name]: Notify,
			[Dialog.name]: Dialog,
		},
		data() {
			return {
				mx: '信息技术服务',
				ys: '1',
				type: '1',
				types: '1',
				repeatBtn: '1',
				aaa: '广东省公路三类人员培训考试',
				activeNames: ['1'],
				disableds: false,
				openid: '',
				invoiceId: '',
				form: {},
				form1: {
					invoiceType: '电子普通发票',
					invoiceHead: '2',
					invoiceCompe: '',
					socialCreditCode: '',
					invoiceEmail: '',
					invoicePhone: '',
					amount: '',
					address: '',
					bankName: '',
					bankNumber: '',
					phone: ''
				},
				// 支付
				form2: {
					openid: '',
					subsystemId: '',
					buyType: '',
					payType: '',
					invoiceId: '',
					isInvoice: ''
				},
				// 月 半年 一年
				form3: {
					endTime: '',
					amount: '',
					payName: '',
				},
				form4: {},
				isInvoice: '1', //是否开发票
				buyType: '1', //购买月份
				payType: '2', //支付方式
				dateTimeString: '', //2019年12月
				costAmount: '', //1
				offerAmount: '', //	0.99
				discountAmount: '', //0.01,
				dateTimeString1: '', //2019年12月
				costAmount1: '', //1
				offerAmount1: '', //	0.99
				discountAmount1: '', //0.01,
				dateTimeString2: '', //2019年12月
				costAmount2: '', //1
				offerAmount2: '', //	0.99
				discountAmount2: '' //0.01,
			};
		},
		created() {
			let _this = this;
			document.title = "交道发布";

			function GetQueryString(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			}
			// 调用方法
			if (GetQueryString('openid') != '' && GetQueryString('openid') != null) {
				localStorage.setItem('openid', GetQueryString('openid'));
			}
			_this.openid = localStorage.getItem('openid');
			this.findLatestInvoiceInfoGet();
			// 查询单价等
			let urls = Global.env + Global.apiCore.findPreOrder;
			return new Promise((resolve, reject) => {
				request({
						url: urls,
						method: 'post',
						data: {
							accessTokenWap: localStorage.getItem('token')
						},
					})
					.then(response => {
						if (response.resultCode == '1000') {
							this.form3 = response.data.preOrderVO;
						}else{
							Dialog.alert({
								message: response.resultDesc,
							}).then(() => {
								this.$router.push({
									name: 'OpenMemberLogin',
									query: {
									}
								});
							});
						}
					})
					.catch(error => {
						Dialog.alert({
							message: error.errmsg
						}).then(() => {
							// on close
						});
						return reject(error);
					});
			});
			
			
		},
		// this.$route.query.subsystemId;
		// this.$route.query.costMode;

		methods: {
			findLatestInvoiceInfoGet(){
				// 开票前查询最新的发票信息
				let findLatestInvoiceInfoUrl = Global.env + Global.apiCore.findLatestInvoiceInfo;
				return new Promise((resolve, reject) => {
					request({
							url: findLatestInvoiceInfoUrl,
							method: 'post',
							data: {
								accessTokenWap: localStorage.getItem('token')
							},
						})
						.then(response => {
							if (response.resultCode == '1000') {
								this.form1 = response.data.invoiceInfo;
							}
						})
						.catch(error => {
							Dialog.alert({
								message: error.errmsg
							}).then(() => {
								// on close
							});
							return reject(error);
						});
				});
			},
			
			
			
			fanhui() {
				this.$router.push({
					name: 'OpenMemberLogin',
					query: {}
				});
			},
			setPayTypes(e) {
				// let _this = this;
				// _this.buyType = e;
				// if (e == 1) {
				// 	this.ys = '1';
				// 	this.form3.dateTimeString = this.dateTimeString;
				// 	this.form3.costAmount = this.costAmount;
				// 	this.form3.offerAmount = this.offerAmount;
				// 	this.form3.discountAmount = this.discountAmount;
				// } else if (e == 6) {
				// 	this.ys = '2';
				// 	this.form3.dateTimeString = this.dateTimeString1;
				// 	this.form3.costAmount = this.costAmount1;
				// 	this.form3.offerAmount = this.offerAmount1;
				// 	this.form3.discountAmount = this.discountAmount1;
				// } else if (e == 12) {
				// 	this.ys = '3';
				// 	this.form3.dateTimeString = this.dateTimeString2;
				// 	this.form3.costAmount = this.costAmount2;
				// 	this.form3.offerAmount = this.offerAmount2;
				// 	this.form3.discountAmount = this.discountAmount2;
				// }
			},
			fp(e) {
				let _this = this;
				_this.isInvoice = e;
				// alert(_this.form2.isInvoice)
				if (e == 1) {
					this.type = '1';
				} else {
					this.type = '';
					this.activeNames = [];
				}
			},
			qx() {
				let _this = this;
				_this.activeNames = [];
			},
			qd() {
				let _this = this;
				if (_this.form1.invoiceCompe == '') {
					Notify('发票抬头不能为空');
					return false;
				}
				if (!isNaN(Number(_this.form1.invoiceCompe))) { //当输入不是数字的时候，Number后返回的值是NaN;然后用isNaN判断。
					Notify('请输入正确发票抬头');
					return false;
				}
				if (_this.form1.invoiceHead == '2') {
					// alert(11111)
					if (_this.form1.socialCreditCode == '') {
						Notify('税号不能为空');
						return false;
					}
				} else {
					// alert(2222)
					let socialCreditCode = /^\d{15}|\d{18}$/;
					if (!socialCreditCode.test(_this.form1.socialCreditCode)) {
						Notify('身份证格式不正确');
						_this.form1.socialCreditCode.invoiceEmail = '';
						return false;
					}
				}
				let invoiceEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				if (!invoiceEmail.test(this.form1.invoiceEmail)) {
					Notify('邮箱格式不正确');
					this.form1.invoiceEmail = '';
					return false;
				}
				let invoicePhone = /^1[0-9]{10}$/;
				if (!invoicePhone.test(this.form1.invoicePhone)) {
					Notify('手机号格式不正确');
					this.form1.invoicePhone = '';
					return false;
				}
				if (_this.form1.invoiceHead == '2') {
					if (_this.form1.address == '') {
						Notify('企业不能为空');
						return false;
					}
				}
				let phone = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
				if (_this.form1.invoiceHead == '2') {
					if (!phone.test(this.form1.phone)) {
						Notify('企业电话格式不正确');
						this.form1.phone = '';
						return false;
					}
				}

				let urls = Global.env + Global.apiCore.invoiceAdds;
				return new Promise((resolve, reject) => {
					request({
							url: urls,
							method: 'post', //查询一般为get
							data: {
								accessTokenWap: localStorage.getItem('token'),
								invoiceType: _this.form1.invoiceType,
								invoiceHead: _this.form1.invoiceHead,
								invoiceCompe: _this.form1.invoiceCompe,
								socialCreditCode: _this.form1.socialCreditCode,
								invoiceEmail: _this.form1.invoiceEmail,
								invoicePhone: _this.form1.invoicePhone,
								address: _this.form1.address,
								bankName: _this.form1.bankName,
								bankNumber: _this.form1.bankNumber,
								phone: _this.form1.phone,
								amount: _this.form3.amount
							} //get
						})
						.then(response => {
							if (response.resultCode == '1000') {
								_this.invoiceId = response.data.id;
								_this.activeNames = [];
								_this.disableds = true;
							}
						})
						.catch(error => {
							Dialog.alert({
								message: error.errmsg
							}).then(() => {
								// on close
							});
							return reject(error);
						});
				});
				console.log(this.form1);
			},
			zf1() {
				Notify('存在有效订单，不允许缴费。');
			},
			zf() {
				let _this = this;
				_this.repeatBtn = '2';
				if (_this.form3.amount == 0 || _this.form3.amount == '' || _this.form3.amount == null) {

				} else {
					if (this.isInvoice == '1') {
						if (this.invoiceId == '' || this.invoiceId == null) {
							_this.repeatBtn = '1';
							Notify('请填写发票信息');
							return false;
						}
					}
					let urls = Global.env + Global.apiCore.zfhy;
					return new Promise((resolve, reject) => {
						request({
								url: urls,
								method: 'post', //查询一般为get
								data: {
									accessTokenWap: localStorage.getItem('token'),
									openid: _this.openid,
									payType: '2',
									invoiceId: _this.invoiceId,
									isInvoice: _this.isInvoice
								} //get
							})
							.then(response => {
								if (response.resultCode == '1000') {
									_this.form4 = response.data.payResponse;
									function onBridgeReady() {
										WeixinJSBridge.invoke(
											'getBrandWCPayRequest', {
												appId: _this.form4.appId, //公众号名称，由商户传入
												timeStamp: _this.form4.timeStamp, //时间戳，自1970年以来的秒数
												nonceStr: _this.form4.nonceStr, //随机串
												package: _this.form4.packAge,
												signType: 'MD5', //微信签名方式：
												paySign: _this.form4.paySign //微信签名
											},
											function(res) {
												// alert('res')
												_this.repeatBtn = '1';
												if (res.err_msg == 'get_brand_wcpay_request:ok') {
													// alert("ok")
													// window.location.href = 'http://m-test.jiaodao11.com/paymentResultMember';
													window.location.href = 'https://m.jiaodao11.com/paymentResultMember';
													// 使用以上方式判断前端返回,微信团队郑重提示：
													//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
												}
											}
										);
									}
									onBridgeReady();
									console.log(response);
								} else {
									_this.repeatBtn = '1';
									Notify(response.resultDesc);
								}
							})
							.catch(error => {
								_this.repeatBtn = '1';
								Notify(error.errmsg);
								return reject(error);
							});
					});
				}
			}
		}
	};
</script>
<style rel="stylesheet/scss" lang="scss">
	.paymentOrder {
		#big {
			width: 100%;
			height: 100%;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			background: #f9f9f9;
		}

		#imgFanhui {
			display: block;
			width: 0.2rem;
			height: 0.36rem;
			position: absolute;
			left: 0.3rem;
			top: 0.26rem;
		}

		#header {
			width: 100%;
			height: 0.98rem;
			line-height: 0.98rem;
			background: #383952;
			text-align: center;
			font-size: 0.36rem;
			font-weight: 400;
			color: #fff;
		}

		#main {
			flex: 1;
			background: #f8f8f8;
			overflow-y: auto;
		}

		#nav {
			width: 100%;
			// height: 2rem;
			background: #fff;
			margin-top: 0.2rem;
			margin-bottom: 0.2rem;
		}

		#nav p {
			/*float: left;*/
			display: inline-block;
			width: 1.46rem;
			height: 0.68rem;
			line-height: 0.68rem;
			text-align: center;
			font-size: 0.36rem;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			border: 1px solid rgba(50, 51, 51, 1);
			margin: 0.32rem 0 0.2rem 0.72rem;
		}

		.ys {
			color: #f63c45 !important;
			border: 1px solid #f63c45 !important;
		}

		.ys1 {
			color: #f63c45 !important;
			border: 1px solid #f63c45 !important;
		}

		.ys2 {
			color: #f63c45 !important;
			border: 1px solid #f63c45 !important;
		}

		#money {
			width: 100%;
			height: auto;
			background: #fff;
			margin-bottom: 0.2rem;
		}

		#money p {
			width: 92.5%;
			height: 1.12rem;
			line-height: 1.12rem;
			border-bottom: 1px solid rgba(205, 205, 205, 1);
			margin: 0 auto;
		}

		#money p a {
			float: left;
			font-size: 0.32rem;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			color: #333333;
		}

		#money p span {
			float: right;
			font-size: 0.32rem;
			font-weight: 400;
		}

		#money p span a {
			color: rgba(51, 51, 51, 1);
		}

		#need {
			color: rgba(255, 180, 0, 1) !important;
		}

		#btn {
			width: 92.5%;
			height: 0.82rem;
			line-height: 0.82rem;
			background: #f63c45;
			border-radius: 4px;
			margin: 0 auto;
			margin-top: 0.88rem;
			text-align: center;
			font-weight: 400;
			color: rgba(255, 255, 255, 1);
			font-size: 0.34rem;
			margin-bottom: 0.2rem;
			cursor: pointer;
			overflow: hidden;
		}

		#showTime {
			font-size: 0.32rem;
			line-height: 0.72rem;
			padding-left: 0.7rem;
		}

		.table-main {
			width: 100%;
			height: auto;
			background: #fff;
		}

		.table-main1 {
			width: 100%;
			height: auto;
			background: #fff;
			overflow: hidden;
		}

		.table-main p {
			width: 92.5%;
			height: 1.12rem;
			line-height: 1.12rem;
			border-bottom: 1px solid rgba(205, 205, 205, 1);
			margin: 0 auto;
			overflow: hidden;
		}

		.table-main p a {
			float: left;
			font-size: 0.32rem;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			color: #333333;
		}

		.table-main p span {
			float: right;
			font-size: 0.32rem;
			font-weight: 400;
		}

		.table-main p span a {
			color: rgba(51, 51, 51, 1);
		}

		.fp {
			display: block;
			width: 1.52rem;
			height: 0.62rem;
			line-height: 0.62rem;
			text-align: center;
			color: #333333;
			border: 1px solid #323333;
			margin-top: 0.26rem;
			margin-left: 0.3rem;
		}

		.fp:hover {
			color: #fff;
			background: #f63c45;
			border-color: #f63c45;
		}

		.fp11 {
			display: block;
			width: 1.52rem;
			height: 0.62rem;
			line-height: 0.62rem;
			text-align: center;
			color: #333333;
			border: 1px solid #323333;
			margin-top: 0.26rem;
			margin-left: 0.3rem;
		}

		.fpss {
			display: block;
			width: 2.8rem;
			height: 0.62rem;
			line-height: 0.62rem;
			text-align: center;
			color: #333333;
			border: 1px solid #323333;
			margin-top: 0.26rem;
			margin-bottom: 0.26rem;
			margin-left: 0.3rem;
			border-radius: 4px;
		}

		.fpss1 {
			display: block;
			width: 2.8rem;
			height: 0.62rem;
			line-height: 0.62rem;
			text-align: center;
			color: #333333;
			border: 1px solid #323333;
			margin-top: 0.26rem;
			margin-bottom: 0.26rem;
			margin-right: 0.3rem;
			border-radius: 4px;
		}

		.fpss:hover {
			color: #fff;
			background: #f63c45;
			border-color: #f63c45;
		}

		.fpss1:hover {
			color: #fff;
			background: #f63c45;
			border-color: #f63c45;
		}

		.fpxx {
			display: block;
			width: 2.5rem;
			height: 0.62rem;
			line-height: 0.62rem;
			text-align: center;
			color: #333333;
			border: 1px solid #323333;
			margin-top: 0.26rem;
			margin-left: 0.3rem;
		}

		.fpxx:hover {
			color: #fff;
			background: #f63c45;
			border-color: #f63c45;
		}

		.fps {
			color: #fff;
			background: #f63c45;
			border-color: #f63c45;
		}

		.table-kfp {
			height: 0.88rem;
			width: 100%;
			background: #f3f3f4;
		}

		.table-kfp p {
			width: 92.5%;
			height: 0.88rem;
			line-height: 0.88rem;
			margin: 0 auto;
			font-size: 0.32rem;
			color: #666666;
		}

		.table-main1 p {
			width: 92.5%;
			height: 1.12rem;
			line-height: 1.12rem;
			border-bottom: 1px solid rgba(205, 205, 205, 1);
			margin: 0 auto;
		}

		.table-main1 p a {
			float: left;
			font-size: 0.32rem;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			color: #333333;
		}

		.table-main1 p span {
			float: right;
			font-size: 0.32rem;
			font-weight: 400;
		}

		.table-main1 p span a {
			color: rgba(51, 51, 51, 1);
		}

		.table-main1 .inputs {
			float: right;
			width: 5.2rem;
			height: 0.95rem !important;
			line-height: 0.96rem !important;
			text-align: right;
			color: #666666;
			font-size: 0.32rem;
			border: none;
		}

		.van-cell {
			position: relative;
			display: -webkit-box;
			display: -webkit-flex;
			display: flex;
			margin: 0 auto;
			box-sizing: border-box;
			width: 92.5%;
			/* padding: .13333rem .21333rem; */
			overflow: hidden;
			color: #323233;
			font-size: 0.32rem !important;
			line-height: 0.32rem;
			background-color: #fff;
			padding: 0.3rem 0;
			border: none !important;
			border-bottom: 1px solid rgba(205, 205, 205, 1);
		}

		#gs {
			position: absolute;
			font-size: 0.32rem;
			z-index: 123;
			right: 0.8rem;
			top: 0.26rem;
		}

		.van-collapse-item__content {
			padding: 0 !important;
			color: #969799;
			font-size: 0.32rem !important;
			line-height: 1.5;
			background-color: #fff;
		}

		input {
			background: #fff;
			border: none;
		}

		input[type='radio']+label::before {
			content: '\a0';
			/*不换行空格*/
			display: inline-block;
			vertical-align: middle;
			font-size: 18px;
			width: 1em;
			height: 1em;
			margin-right: 0.4em;
			border-radius: 50%;
			border: 1px solid #01cd78;
			text-indent: 0.15em;
			line-height: 1;
		}
	}
</style>
